// extracted by mini-css-extract-plugin
export default {"LinkButton":"LinkButton_LinkButton__ydSl5"};